import { CustomRole, CustomRoleItem } from "@/common/customRole";
import { FeatureName, ModuleName } from "@/common/product";
import { Language } from "@/i18n/languages";

const advisorRoleTemplate: CustomRole = {
  orgNo: "",
  customRoleId: "template",
  customRoleName: "advisor",
  modules: [
    ModuleName.OVERVIEW,
    ModuleName.SHAREHOLDER_REGISTER,
    ModuleName.DBOT,
    ModuleName.ARCHIVE,
    ModuleName.MESSAGING,
  ],
  features: [
    {
      featureName: FeatureName.dashboard,
      access: "EDIT",
    },
    {
      featureName: FeatureName.articles,
      access: "EDIT",
    },
    {
      featureName: FeatureName.poas,
      access: "EDIT",
    },
    {
      featureName: FeatureName.ownership,
      access: "EDIT",
    },
    {
      featureName: FeatureName.companyRoles,
      access: "EDIT",
    },
    {
      featureName: FeatureName.companySettings,
      access: "EDIT",
    },
    {
      featureName: FeatureName.shareholders,
      access: "EDIT",
    },
    {
      featureName: FeatureName.transactions,
      access: "EDIT",
    },
    {
      featureName: FeatureName.shareClasses,
      access: "EDIT",
    },
    {
      featureName: FeatureName.shareholderRegisterStatement,
      access: "EDIT",
    },
    {
      featureName: FeatureName.beneficialOwners,
      access: "EDIT",
    },
  ],
  customRoleLanguages: [
    {
      customRoleId: "e",
      language: Language.NO,
      name: "Rådgiver",
      description: "",
    },
    {
      customRoleId: "00000000-0000-0000-0000-000000000000",
      language: Language.EN,
      name: "Advisor",
      description: "",
    },
    {
      customRoleId: "00000000-0000-0000-0000-000000000000",
      language: Language.SV,
      name: "Rådgiver",
      description: "",
    },
  ],
};

const shareholderRegisterReadRoleTemplate: CustomRole = {
  orgNo: "",
  customRoleId: "template",
  customRoleName: "shareholdersRead",
  modules: [ModuleName.SHAREHOLDER_REGISTER],
  features: [
    {
      featureName: FeatureName.shareholderRegisterDashboard,
      access: "VIEW",
    },
    {
      featureName: FeatureName.shareholders,
      access: "VIEW",
    },
    {
      featureName: FeatureName.transactions,
      access: "VIEW",
    },
    {
      featureName: FeatureName.shareClasses,
      access: "VIEW",
    },
    {
      featureName: FeatureName.capTable,
      access: "VIEW",
    },
  ],
  customRoleLanguages: [
    {
      customRoleId: "00000000-0000-0000-0000-000000000000",
      language: Language.NO,
      name: "Aksjeeierregister Les",
      description: "",
    },
    {
      customRoleId: "00000000-0000-0000-0000-000000000000",
      language: Language.EN,
      name: "Shareholder Register Read",
      description: "",
    },
    {
      customRoleId: "00000000-0000-0000-0000-000000000000",
      language: Language.SV,
      name: "Aktieägarregister Läs",
      description: "",
    },
  ],
};

const shareholderRegisterAdminRoleTemplate: CustomRole = {
  orgNo: "",
  customRoleId: "template",
  customRoleName: "shareholdersAdmin",
  modules: [ModuleName.SHAREHOLDER_REGISTER, ModuleName.ARCHIVE, ModuleName.MESSAGING],
  features: [
    {
      featureName: FeatureName.shareholderRegisterDashboard,
      access: "VIEW",
    },
    {
      featureName: FeatureName.shareholders,
      access: "EDIT",
    },
    {
      featureName: FeatureName.transactions,
      access: "EDIT",
    },
    {
      featureName: FeatureName.shareClasses,
      access: "EDIT",
    },
    {
      featureName: FeatureName.shareholderRegisterStatement,
      access: "EDIT",
    },
    {
      featureName: FeatureName.beneficialOwners,
      access: "EDIT",
    },
    {
      featureName: FeatureName.shareholderArchive,
      access: "EDIT",
    },
    {
      featureName: FeatureName.shareholderMessages,
      access: "EDIT",
    },
  ],
  customRoleLanguages: [
    {
      customRoleId: "00000000-0000-0000-0000-000000000000",
      language: Language.NO,
      name: "Aksjeeierregister Admin",
      description: "",
    },
    {
      customRoleId: "00000000-0000-0000-0000-000000000000",
      language: Language.EN,
      name: "Shareholder Register Admin",
      description: "",
    },
    {
      customRoleId: "00000000-0000-0000-0000-000000000000",
      language: Language.SV,
      name: "Aktieägarregister Admin",
      description: "",
    },
  ],
};

export const roleTemplates: CustomRoleItem[] = [
  { role: advisorRoleTemplate, users: [], availableUsers: [], companies: [] },
  { role: shareholderRegisterReadRoleTemplate, users: [], availableUsers: [], companies: [] },
  { role: shareholderRegisterAdminRoleTemplate, users: [], availableUsers: [], companies: [] },
];
